import { userRequestedSearch } from '@web-platform/shared-banana-redux/src/actions/searchControls';
import { useCombinedResultsSearch } from '@web-platform/shared-banana-redux/src/helpers/navigationHandlers/useCombinedResultsSearch';
import { stopsFilterChanged } from '@web-platform/shared-universal-redux/src/actions/filters';
import { useDispatch } from 'react-redux';

import type { InternalGCSearchParams } from '@skyscanner-internal/global-components/flights-search-controls/common/types/search';
import type { MBDEventTracking } from '@web-platform/shared-banana-tracking/src/trackMBD/MBDEventTracking';

const useSearch = (
  parallelSearchTracking?: MBDEventTracking,
  packagesParallelSearchTracking?: MBDEventTracking,
) => {
  const dispatch = useDispatch();
  const { goToCombinedResultsFromFlightsSearchControlsGC } = useCombinedResultsSearch(
    parallelSearchTracking,
    packagesParallelSearchTracking,
  );

  return (params: InternalGCSearchParams) => {
    if (params.legs && params.legs[0] && params.legs[0].return_date === undefined) {
      // eslint-disable-next-line no-param-reassign
      delete params.legs[0].return_date;
    }

    if (params.prefer_directs) {
      dispatch(
        stopsFilterChanged({
          direct: true,
          oneStop: false,
          twoPlusStops: false,
        }),
      );
    }

    dispatch(userRequestedSearch(true));
    goToCombinedResultsFromFlightsSearchControlsGC(params);
  };
};

export default useSearch;
